import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import { updateUserProfile } from 'common/api/auth';
import { isJsonString } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import { SAVE, SAVE_SUCCESS, SAVE_FAILURE } from '../actionTypes';
import { profileActions } from '../reducer';

import initializeForm from './initializeForm';
import setCurrentValues from './setCurrentValues';

export default (values) => (dispatch) => {
    var newValues = new FormData();
    newValues.append('first_name', values.first_name);
    newValues.append('last_name', values.last_name);

    if (Array.isArray(values.picture)) {
        newValues.append('picture', values.picture && values.picture[0]);
    }

    dispatch(profileActions[SAVE]());

    updateUserProfile(newValues, values.id)
        .then((response) => {
            const json = localStorage.getItem('session');
            const session = isJsonString(json)
                ? JSON.parse(localStorage.getItem('session'))
                : null;

            if (!isEmpty(session) && !isNil(session)) {
                session.first_name = response?.data?.first_name;
                session.last_name = response?.data?.last_name;
                if (!isNil(response?.data?.picture))
                    session.picture = response?.data?.picture;

                localStorage.setItem('session', JSON.stringify(session));
            }

            dispatch(profileActions[SAVE_SUCCESS](response.data));

            dispatch(
                setCurrentValues({
                    ...response?.data,
                    picture: session.picture,
                }),
            );

            dispatch(
                initializeForm({
                    ...response?.data,
                    picture: session.picture,
                }),
            );

            showToast();
        })
        .catch((error) =>
            dispatch(
                profileActions[SAVE_FAILURE](error?.response?.data?.errors),
            ),
        );
};
